<template>
  <div class="filtersContent">
    <FiltersContentScrollButtonTop />
    <div class="filtersScrollContainer">
      <div class="filtersTop">
        <BaseToggle
          class="w-full"
          :checked="filtersStore.isAnyFilterActive.value"
          :text="$l('showresult.filter.useSavedFilters')"
          @update:checked="filtersStore.toggleEnabled(!filtersStore.isAnyFilterActive.value)"
        />
      </div>
      <div class="filtersLayout">
        <!-- Views -->
        <div class="filtersViews">
          <component
            :is="item.component"
            v-for="(item, i) in components"
            :key="i"
            :class="{
              'filtersView--visible': componentCurrent === i
            }"
            :aria-label="item.text"
          />
        </div>
      </div>
    </div>
    <FiltersContentScrollButtonBottom />
  </div>
</template>

<script setup>

import { l, lreplace } from '@js/utils/toolbox';
import { useFiltersStore } from './store/filtersStore';
const filtersStore = useFiltersStore();

const componentCurrent = ref(0);
const components = [
	{
		component: 'FiltersItemPrice',
		text: l('showresult.filter.priceTitle'),
		ariaLabel: lreplace('ariaLabels.filterBy', { s: l('showresult.filter.priceTitle') }),
		icon: 'hand-cube-hand',
		propertyKeys: ['price', 'flexTicket', 'baggageIncluded', 'youthTicket', 'baggageIncluded', 'cabinBaggageIncluded', 'rebookableFlights', 'climateCompensated', 'paymentMethodIncluded']
	},
	{
		component: 'FiltersItemTransfers',
		text: l('showresult.filter.transfersTitle'),
		ariaLabel: lreplace('ariaLabels.filterBy', { s: l('showresult.filter.transfersTitle') }),
		icon: 'transfer',
		propertyKeys: ['numStops', 'changesAirport', 'airportWaitTime']
	},
	{
		component: 'FiltersItemTime',
		text: l('showresult.filter.timeTitle'),
		ariaLabel: lreplace('ariaLabels.filterBy', { s: l('showresult.filter.timeTitle') }),
		icon: 'circle-time',
		propertyKeys: ['traveltime', 'departureTime', 'arrivalTime']
	},
	{
		component: 'FiltersItemAirlines',
		text: l('showresult.filter.airlinesTitle'),
		ariaLabel: lreplace('ariaLabels.filterBy', { s: l('showresult.filter.airlinesTitle') }),
		icon: 'airlines',
		propertyKeys: ['enabledAirlines', 'blacklisted', 'alliances']
	},
	{
		component: 'FiltersItemTicketType',
		text: l('searchBox.ticketType.label'),
		ariaLabel: lreplace('ariaLabels.filterBy', { s: l('searchBox.ticketType.label') }),
		icon: 'icon-seating-unknown',
		propertyKeys: ['ticketType'],
		isVisible: window.js_params.module.Filters.isTicketTypeFilterEnabled
	},
	{
		component: 'FiltersItemAirports',
		text: l('global.simplePhrases.airports'),
		ariaLabel: lreplace('ariaLabels.filterBy', { s: l('global.simplePhrases.airports') }),
		icon: 'steering-wheel',
		propertyKeys: ['airportDepartures', 'airportArrivals', 'airportStops']
	},
	{
		component: 'FiltersItemAgencies',
		text: l('showresult.filter.travelAgencyFilterTitle'),
		ariaLabel: lreplace('ariaLabels.filterBy', { s: l('showresult.filter.travelAgencyFilterTitle') }),
		icon: 'transfer',
		propertyKeys: ['enabledAgents', 'foreign']
	},
	{
		component: 'FiltersItemSorting',
		text: l('showresult.filter.sortingFilterTitle'),
		ariaLabel: lreplace('ariaLabels.filterBy', { s: l('showresult.filter.sortingFilterTitle') }),
		icon: 'transfer',
		propertyKeys: ['numStops', 'changesAirport', 'airportWaitTime']
	}
	// {
	// 	component: 'FiltersItemTransport',
	// 	text: 'Transport',
	// 	icon: 'steering-wheel',
	// 	propertyKeys: ['excludedTravelMethods', 'excludedProducers']
	// }
	// ,...(isDevelopment ? [{ component: 'FiltersItemDeveloper', text: 'Transport', icon: 'coffee', propertyKeys: [] }] : [])
].filter(item => item.isVisible === undefined || item.isVisible);

</script>


<style lang="scss">
.filtersScrollBtn {
  z-index: 999;
  position: sticky;
  width: 25.6rem;
  height: 5rem;
  background-color: $white;
  cursor: pointer;
  transition: all 0.3s linear;
  height: 0;
  opacity: 0;
  pointer-events: none;
}

.filtersScrollBtn--visible {
    opacity: 1;
    pointer-events: auto;
}

.filtersScrollBtn__arrows {
  display: flex;
  color: $main-font-color;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: $white;
  font-size: 1.8rem;
  height: 5rem;

  & > * {
    pointer-events: none;
  }

  &::before,
  &::after {
    font-family: "icomoon";
    display: block;
    line-height: 0.4;
  }
}

.filtersScrollBtn--up {
  box-shadow: 0.1rem 0.6rem 1rem 0 rgba(46, 91, 139, 0.09);
  top: 0;

  .filtersScrollBtn__arrows {
    &::before,
    &::after {
      content: "\e907";
    }
  }
}

.filtersScrollBtn--down {
  box-shadow: -0.1rem -0.6rem 1rem 0 rgba(46, 91, 139, 0.09);
  bottom: 5rem;
  position: fixed;

  .filtersScrollBtn__arrows {
    &::before,
    &::after {
      content: "\e917";
    }
  }
}
</style>
